import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from "vue";

// Props recibidas

export default /*#__PURE__*/_defineComponent({
  __name: 'ModalAddPuntosPartida',
  props: {
  isVisible: Boolean,
  idPartidaTorneo: Number,
  usuario: Number,
},
  emits: ["confirmar", "cerrar"],
  setup(__props, { emit: __emit }) {

const props = __props;

// Emite evento para cerrar el modal y enviar los puntos
const emit = __emit;

// Variables reactivas
const isModalPuntosVisible = ref(true);
const puntos = ref<number>(0);

// Cerrar el modal
const cerrarModal = () => {
  emit("cerrar");
};

// Confirmar los puntos y cerrar el modal
const confirmarPuntos = () => {
  emit("confirmar", puntos.value);
  cerrarModal();
};

// Monitorea cambios en la visibilidad del modal
watch(
  () => props.isVisible,
  (newVal) => {
    isModalPuntosVisible.value = newVal;
  }
);

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    modelValue: isModalPuntosVisible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((isModalPuntosVisible).value = $event)),
    "max-width": "400"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_card, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, null, {
            default: _withCtx(() => [
              _createTextVNode(" Ingresar Puntos ")
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_form, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_text_field, {
                    modelValue: puntos.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((puntos).value = $event)),
                    label: "Puntos",
                    type: "number",
                    min: "0",
                    required: ""
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_actions, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                small: "",
                variant: "tonal",
                color: "primary",
                onClick: confirmarPuntos
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Confirmar ")
                ]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                small: "",
                variant: "tonal",
                color: "secondary",
                onClick: cerrarModal
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Cancelar ")
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})